export default __webpack_public_path__ + "static/media/Highlights.f4e04809.png";